module.exports = __webpack_public_path__ + "media/icons/breadcrumbs-arrow-blue@3x-dc4da42d.svg";